import axios from '../utils/axios'

// 获取验证码
export const GetSecurityCodeBySms = (data) => axios({
	data,
	url: '/Mobile/Account/GetSecurityCodeBySms',
	method: 'post',
})

// 注册账号
export const CreateStoreUserWithSecurityCode = (data, fromApp = '', partner = '') => axios({
	data,
	url: `/Mobile/Account/CreateStoreUserWithSecurityCode?fromApp=${ fromApp }&partner=${ partner }`,
	method: 'post',
})

//获取问题列表
export const GetProblem = (id = '01') => axios({
	url: `//imgw.pospal.cn/pospalCS/problem/${ id }.json`,
	method: 'get'
})

//保存问题
export const SaveRegisterQuestionnaire = (data) => axios({
	data,
	url: '/Mobile/Account/SaveRegisterQuestionnaire',
	method: 'post',
})


// WEBPACK FOOTER //
// ./src/service/request.js